import { Reveal, Overline } from "./Reveal";
import { SWATCHES } from "../lib/site";

export const SwatchRange = () => (
  <section id="colours" data-testid="swatch-range-section" className="scroll-mt-20 bg-lec-bone">
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-10 md:py-28">
      <Reveal>
        <Overline>Our preferred supplier — Limecrete</Overline>
        <div className="mt-6 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <h2 className="max-w-2xl font-display text-4xl font-semibold tracking-tight text-lec-ink sm:text-5xl lg:text-6xl">
            Pick your stone.
          </h2>
          <p className="max-w-md text-base leading-relaxed text-lec-charcoal">
            We pour with mixes from Limecrete, the local decorative concrete specialists. The
            Kajanni range below is the crowd favourite — the full colour range is on the table at
            your onsite consult.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-5 sm:grid-cols-4" data-testid="swatch-grid">
        {SWATCHES.map((s, i) => (
          <Reveal key={s.name} delay={(i % 4) * 0.06}>
            <figure data-testid={`swatch-${i}`} className="group">
              <div className="overflow-hidden border border-lec-ink/10">
                <img
                  src={s.src}
                  alt={`${s.name} concrete swatch`}
                  loading="lazy"
                  className="aspect-square w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                />
              </div>
              <figcaption className="mt-3 flex items-start justify-between gap-2">
                <span className="text-xs font-bold uppercase tracking-[0.12em] text-lec-ink">
                  {s.name}
                </span>
                <span className="mt-0.5 inline-block h-2 w-2 shrink-0 rotate-45 bg-lec-green" />
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

    </div>
  </section>
);
